import { render } from "./PaymentContent.vue?vue&type=template&id=1ccfc518&scoped=true"
import script from "./PaymentContent.vue?vue&type=script&lang=js"
export * from "./PaymentContent.vue?vue&type=script&lang=js"

import "./PaymentContent.vue?vue&type=style&index=0&id=1ccfc518&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ccfc518"]])

export default __exports__